
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.75 10.53l-6 5.25c-.535.469-1.464.14-1.464-.531v-3H6.43c-.475 0-.857-.334-.857-.75v-3c0-.415.382-.749.857-.749h4.857v-3c0-.668.925-1 1.465-.53l6 5.249a.69.69 0 010 1.062zM7.858 15.625v-1.25c0-.206-.192-.375-.428-.375h-3c-.632 0-1.143-.447-1.143-1V7c0-.553.51-1 1.143-1h3c.236 0 .428-.168.428-.375v-1.25c0-.206-.192-.374-.428-.374h-3C2.536 4 1 5.344 1 7v5.998c0 1.656 1.536 3 3.429 3h3c.236 0 .428-.17.428-.375z","fill":"#999"}})])
          )
        }
      }
    